// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"53c2daf7","582":"d8e043ef","733":"c52248fb","887":"1a49c704"}[chunkId] + ".chunk.js";
};